import ProtectedRoute from 'components/ProtectedRoute';

import NewUnitTransferRequest from './NewUnitTransferRequest';
import UnitTransferAcknowledgement from './UnitTransferAcknowledgement';
import UnitTransferPreview from './UnitTransferPreview';
import UnitTransferRequestTracker from './UnitTransferRequest';
import UnitTransferDocuments from './UnitTransferRequest/Documents';
import UnitTransferSignatures from './UnitTransferRequest/Signatures';

const routes = [
  {
    path: '/invest/unit-transfers',
    children: [
      {
        path: 'new',
        element: (
          <ProtectedRoute>
            <NewUnitTransferRequest />
          </ProtectedRoute>
        ),
      },
      {
        path: ':requestId',
        element: (
          <ProtectedRoute>
            <UnitTransferRequestTracker />
          </ProtectedRoute>
        ),
      },
      {
        path: ':requestId/documents',
        element: (
          <ProtectedRoute>
            <UnitTransferDocuments />
          </ProtectedRoute>
        ),
      },
      {
        path: ':requestId/signatures',
        element: (
          <ProtectedRoute>
            <UnitTransferSignatures />
          </ProtectedRoute>
        ),
      },
      {
        path: ':requestId/acknowledge',
        element: (
          <ProtectedRoute>
            <UnitTransferAcknowledgement />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: '/unit-transfer/preview/:token',
    element: <UnitTransferPreview />,
  },
];

export default routes;
